import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Divider, Form } from 'semantic-ui-react'

import { Feature } from 'app'

import Block from 'components/ui/Block'

import ListOptionSchema from '../../schemas/ListOptionSchema'
import AgentBioSecurityForm from './AgentBioSecurityForm'
import AssistantBioSecurityForm from './AssistantBioSecurityForm'
import PlayerBioSecurityForm from './PlayerBioSecurityForm'

export const ROLES = {
  AGENT: 'AGENT',
  PLAYER: 'PLAYER',
  PUBLIC: 'PUBLIC',
}

class BioSecurityForm extends PureComponent {
  state = { selectedRole: '' }

  handleChange = (e, { value }) => this.setState({ selectedRole: value })

  render() {
    const { allowedRoles, className, error, onSave, positions, teams, values } = this.props
    const { selectedRole } = this.state

    return (
      <div className={className}>
        <p>
          El <b>cuestionario de riesgo</b> es el protocolo clave de la reactivación deportiva:
          <br />
          Conocer el estado de salud de los deportistas protege a las familias.
          <b>¡Contribuyamos!</b>
          <br />
          <br />
          Los <b>jugadores</b> podrán responder la encuesta
          <b> 24 horas</b> antes del encuentro.
          <br />
          El <b>público</b> podrá responder la encuenta
          <b> 1 hora</b> antes y hasta 1 hora después del encuentro.
        </p>
        <h3>¿Para quién llenas el cuestionario?</h3>
        {allowedRoles.includes(ROLES.PLAYER) && (
          <Form.Group>
            <Form.Radio
              checked={selectedRole === ROLES.PLAYER}
              label="Para mi (soy jugador, cuerpo técnico, delegado o cualquier otro que entra en cancha)"
              name="userRole"
              onChange={this.handleChange}
              value={ROLES.PLAYER}
            />
          </Form.Group>
        )}
        <br />
        {Feature.isEnabled('ff_agent_biosecurity_form') && allowedRoles.includes(ROLES.AGENT) && (
          <Form.Group>
            <Form.Radio
              checked={selectedRole === ROLES.AGENT}
              label="Para un jugador menor de 14 (a quien yo represento)"
              name="userRole"
              onChange={this.handleChange}
              value={ROLES.AGENT}
            />
          </Form.Group>
        )}
        <Divider />
        {allowedRoles.includes(ROLES.PUBLIC) && (
          <Form.Group>
            <Form.Radio
              checked={selectedRole === ROLES.PUBLIC}
              label="Solo deseo opinar sobre los protocolos en el torneo"
              name="userRole"
              onChange={this.handleChange}
              value={ROLES.PUBLIC}
            />
          </Form.Group>
        )}
        <Divider />
        <Block>
          {selectedRole === ROLES.PUBLIC && <AssistantBioSecurityForm onSave={onSave} values={values} />}
          {selectedRole === ROLES.PLAYER && (
            <PlayerBioSecurityForm onSave={onSave} positions={positions} teams={teams} values={values} />
          )}
          {selectedRole === ROLES.AGENT && (
            <AgentBioSecurityForm
              error={error}
              onSave={onSave}
              onValidateNIN={this.props.onValidateNIN}
              positions={positions}
              teams={teams}
              values={values}
            />
          )}
        </Block>
      </div>
    )
  }
}

BioSecurityForm.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSave: PropTypes.func.isRequired,
  onValidateNIN: PropTypes.func.isRequired,
  positions: PropTypes.arrayOf(ListOptionSchema).isRequired,
  teams: PropTypes.arrayOf(ListOptionSchema).isRequired,

  className: PropTypes.string,
  error: PropTypes.shape({}),
  values: PropTypes.shape({}),
}

BioSecurityForm.defaultProps = {
  className: '',
  error: {},
  values: {},
}

export default BioSecurityForm
